import React, {useState, useEffect} from 'react';
import {
    FaUserAlt,
    FaRegEnvelope,
    FaPhoneAlt,
    FaBuilding,
    FaRegIdCard,
    FaBirthdayCake,
    FaDatabase,
    FaCopy, FaFileArchive, FaUserClock
} from 'react-icons/fa';
import {LinearProgress, Snackbar} from '@mui/material';
import "./UserSetting.css";
import {jwtDecode} from "jwt-decode";
import axios from "axios";

function UserSettingInfo() {
    const [userData, setUserData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [storageLimit, setStorageLimit] = useState(0);
    const [storageUsedPercent, setStorageUsedPercent] = useState(0);
    const delay = ms => new Promise(res => setTimeout(res, ms));

    useEffect(() => {
        const fetchSettings = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetSettingByKeyWord?Keyword=AddCaseFile`);
            const json = await response.json();
            if (json.success && json.data.data.length > 0) {
                const limitMB = parseInt(json.data.data[0].additionalValue.split('_')[0], 10);
                setStorageLimit(limitMB);
            }
        };

        const fetchData = async () => {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                try {
                    const decoded = jwtDecode(token);
                    const userId = decoded.UserId;
                    setIsLoading(true);
                    const fetchPromise = axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
                    const [response] = await Promise.all([fetchPromise, delay(1500)]);
                    const {data} = response;
                    setUserData(data.data);
                    if (data.data.allFilesSizeMB && storageLimit) {
                        const usedMB = parseFloat(data.data.allFilesSizeMB);
                        const percent = (usedMB / storageLimit) * 100;
                        setStorageUsedPercent(Math.min(percent, 100));
                    }
                } catch (error) {
                    console.error('Failed to fetch user data', error);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchSettings().then(fetchData);
    }, [storageLimit]);

    const formatBirthDate = (dateStr) => {
        const date = new Date(dateStr);
        if (date.getFullYear() <= 1900) return '';
        if (date.getFullYear() >= 2020) return '';
        const formattedDay = ("0" + date.getDate()).slice(-2);
        const formattedMonth = ("0" + (date.getMonth() + 1)).slice(-2);
        return `${formattedDay}.${formattedMonth}.${date.getFullYear()}`;
    };

    const handleCopy = async (text) => {
        if (navigator.clipboard && text) {
            await navigator.clipboard.writeText(text);
            setOpenSnackbar(true);
        }
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    if (isLoading) {
        return <div className="user-setting-container">
            <div style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center', marginTop: "40%"}}>
                <FaUserClock style={{fontSize: 80}} className={"pulse-element"}/>
                <h1>გთხოვთ დაელოდოთ...</h1>
                <p>მონაცემები იტვირთება!</p>
            </div>
        </div>;
    }

    return (
        <div className="user-setting-container">
            <h2 className="user-setting-title">ჩემი ანგარიში</h2>

            {userData.firstName !== " " && (
                <>
                    <div className={"user-settings-param-title"}>სახელი</div>
                    <div className="user-setting-item">
                        <FaUserAlt className="user-setting-icon"/>
                        <p className="user-setting-text">{`${userData.firstName || 'N/A'} ${userData.lastName || 'N/A'}`}</p>
                        <FaCopy className="user-setting-copy-icon"
                                onClick={() => handleCopy(`${userData.firstName} ${userData.lastName}`)}/>
                    </div>
                </>
            )}

            {userData.email && (
                <>
                    <div className={"user-settings-param-title"}>ელ-ფოსტა</div>
                    <div className="user-setting-item">
                        <FaRegEnvelope className="user-setting-icon"/>
                        <p className="user-setting-text">{userData.email}</p>
                        <FaCopy className="user-setting-copy-icon" onClick={() => handleCopy(userData.email)}/>
                    </div>

                </>
            )}
            {userData.pNumber && userData.pNumber.length === 11 && (
                <>
                    <div className={"user-settings-param-title"}>პირადი ნომერი</div>
                    <div className="user-setting-item">
                        <FaRegIdCard className="user-setting-icon"/>
                        <p className="user-setting-text">{userData.pNumber}</p>
                        <FaCopy className="user-setting-copy-icon" onClick={() => handleCopy(userData.pNumber)}/>
                    </div>
                </>
            )}
            {userData.phone && (
                <>
                    <div className={"user-settings-param-title"}>ტელეფონის ნომერი</div>
                    <div className="user-setting-item">
                        <FaPhoneAlt className="user-setting-icon"/>
                        <p className="user-setting-text">{userData.phone}</p>
                        <FaCopy className="user-setting-copy-icon" onClick={() => handleCopy(userData.phone)}/>
                    </div>
                </>
            )}
            {userData.orgName && (
                <>
                    <div className={"user-settings-param-title"}>ორგანიზაციის სახელი</div>
                    <div className="user-setting-item">
                        <FaBuilding className="user-setting-icon"/>
                        <p className="user-setting-text">{userData.orgName}</p>
                        <FaCopy className="user-setting-copy-icon" onClick={() => handleCopy(userData.orgName)}/>
                    </div>
                </>
            )}
            {userData.orgNumber && (
                <>
                    <div className={"user-settings-param-title"}>ორგანიზაციის ნომერი</div>
                    <div className="user-setting-item">
                        <FaBuilding className="user-setting-icon"/>
                        <p className="user-setting-text">{userData.orgNumber}</p>
                        <FaCopy className="user-setting-copy-icon" onClick={() => handleCopy(userData.orgNumber)}/>
                    </div>
                </>
            )}
            {userData.birthDate && formatBirthDate(userData.birthDate) && (
                <>
                    <div className={"user-settings-param-title"}>დაბადების თარიღი</div>
                    <div className="user-setting-item">
                        <FaBirthdayCake className="user-setting-icon"/>
                        <p className="user-setting-text">{formatBirthDate(userData.birthDate)}</p>
                    </div>
                </>
            )}
            {userData.allFilesSizeMB !== null && (
                <>
                    <div className={"user-settings-param-title"}>ატვირთული ფაილების რაოდენობა</div>
                    <div className="user-setting-item">
                        <FaDatabase className="user-setting-icon"/>
                        <p className="user-setting-text">{`${userData.allFilesSizeMB} MB / ${storageLimit} MB`}</p>
                        <div>
                            <LinearProgress
                                variant="determinate"
                                value={storageUsedPercent}

                                color="primary"
                            />
                            <p className="user-setting-percentage">{`გამოყენებულია: ${storageUsedPercent.toFixed(1)}%`}</p>
                        </div>
                    </div>


                </>
            )}

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message="დაკოპირდა"
            />
        </div>
    );
}

export default UserSettingInfo;
